module.exports = __webpack_public_path__ + "img/sii--avatar.5311dd7a.svg";